import React from 'react';
import { RadioProps } from 'antd';
import { StyledRadio, StyledRadioGroup } from './index.styled';

type AppRadioInputProps = RadioProps;

type AppRadioGroupProps = {
  children: React.ReactNode;
};

const AppRadioInput: React.FC<AppRadioInputProps> = ({ ...rest }) => (
  <StyledRadio {...rest} />
);

export const AppRadioGroup: React.FC<AppRadioGroupProps> = ({
  children,
  ...rest
}) => <StyledRadioGroup {...rest}>{children}</StyledRadioGroup>;

export default AppRadioInput;
